import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../Button/Button';
import { capitalizeFirstLetter } from '../../../utils/api';
import { formatNumericDate } from '../../../utils/dates';
import { priorityMap } from '../../../utils/notes';
import { convertUrlsToLinks } from '../../../utils/urlFinder';

const ViewModal = ({ note, actionItemButtons }) => {
  const buttons = Object.fromEntries(
    actionItemButtons.map((b) => [b.label, b]),
  );

  const deleteButton = buttons.Delete;
  const editButton = buttons.Edit;
  return (
    <div>
      <div className="border-b-0.5px border-vamos-blue-gray" />
      <div className="px-5.5 py-8 space-y-2">
        <div className="flex flex-col gap-5.5">
          <div className="flex flex-row gap-1">
            <div className="text-base font-bold">Date:</div>
            <div className="text-base font-normal">{formatNumericDate(note.timestamp)}</div>
          </div>
          <div className="flex flex-row gap-1">
            <div className="text-base font-bold">Author:</div>
            <div className="text-base font-normal line-clamp-1">{note.author}</div>
          </div>
          <div className="flex flex-row gap-1">
            <div className="text-base font-bold">Site:</div>
            <div className="text-base font-normal line-clamp-1">{note.site_name}</div>
          </div>
          <div className="flex flex-row gap-1">
            <div className="text-base font-bold">Status:</div>
            <div className="text-base font-normal">{capitalizeFirstLetter(note.status)}</div>
          </div>
          <div className="flex flex-row gap-1">
            <div className="text-base font-bold">Priority:</div>
            <div className="text-base font-normal">{priorityMap[note.priority].label}</div>
          </div>
          {note.content && (
            <p className="text-lg font-normal rounded-md bg-vamos-v-light-gray p-3 max-h-65.5 overflow-auto" data-testid="note-model-content">{convertUrlsToLinks(note.content)}</p>
          )}
        </div>
      </div>
      <div className="border-b-0.5px border-vamos-blue-gray" />
      <div className="flex flex-row justify-between p-5.5">
        <div> {deleteButton && (
          <Button
            key={deleteButton.label}
            color={deleteButton.variant}
            label={deleteButton.label}
            size="md"
            onClick={deleteButton.onClick}
            dataTestId={deleteButton.dataTestId}
          />
        )}
        </div>
        <div> {editButton && (
          <Button
            key={editButton.label}
            color={editButton.variant}
            label={editButton.label}
            size="md"
            onClick={editButton.onClick}
          />
        )}
        </div>

      </div>
    </div>
  );
};

ViewModal.propTypes = {
  note: PropTypes.object.isRequired,
  actionItemButtons: PropTypes.array.isRequired,
};

export default ViewModal;
